export const RoutePaths = {
  INVITE_CANDIDATES: "invite-candidates",
  CALENDLY: "calendly",
  SETTINGS: "settings",
  DESIGNER_PREVIEW: "preview",
  CV_SCORE_CONFIG: "edit",
  SCORE_CONFIG: "edit",
  APPLICANTS: "applicants",
  MATCHER: "match",
} as const;
